(function ($) {
  var languages = {
    en :{},
    'zh-CN' :{},
    'zh-cn' :{},
    'th' :{},
    'es' :{},
  };
  try {
    languages.en = require('./i18n/en.js');
  } catch (e) {
  }
  try {
    languages['zh-CN'] = require('./i18n/zh-CN.js');
  } catch (e) {
  }
  try {
    languages['zh-cn'] = require('./i18n/zh-CN.js');
  } catch (e) {
  }
  try {
    languages['th'] = require('./i18n/th.js');
  } catch (e) {
  }
  try {
    languages['es'] = require('./i18n/es.js');
  } catch (e) {
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
  }

  /**
   * getDefaultLanguage
   *
   * 1. 第一优先级获取 Cookie 中的 lang
   * 2. 第二优先级 PHP 注入到上下文中的全局变量 defaultLocale
   * 3. 第三优先级 浏览器自带的 [language](https://developer.mozilla.org/en-US/docs/Web/API/Navigator/language) 属性
   * 4. 最后回退到 'en-US' 语言
   *
   * @returns {string}
   */
  function getDefaultLanguage() {
    let language = getCookie('lang') || ''

    if (String(language).length) {
      language = '' + language
    } else {
      language = window.defaultLocale || navigator.language || 'en-US'
    }

    /**
     * 兼容 PHP 配置的 language == 'zh-cn'
     * config/app.php:113
     * // 后端统一用小写，但前端因三方库原因需要地区码大写(zh-CN)，故传给前端（cookie）时可调用CommonHelper::convertLocaleCode()作处理。
     * ```php
     'localeList' => [
     'en'    => "English",
     'th'    => "ภาษาไทย",
     'es'    => "Español",
     'zh-cn' => "简体中文",
     ]
     ```
     */
    if (language === 'zh-cn') {
      language = "zh-CN"
    }

    console.log('Current using language is ', language);

    return language
  }

  const language = getDefaultLanguage()

  window.jsI18n = languages[language] || languages.en;
  console.log('Current using jsI18n is ', jsI18n);

  // 左侧菜单操作
  // initialization of HSMegaMenu component
  //   $('.js-mega-menu').HSMegaMenu({
  //     event: 'hover',
  //     pageContainer: $('.container'),
  //     breakpoint: 1199.98,
  //     hideTimeOut: 0
  //   });
  // initialization of header
  //   $.HSCore.components.HSHeader.init($('#header'));

  // initialization of focus state
  //   $.HSCore.components.HSFocusState.init();

  // initialization of go to
  $.HSCore.components.HSGoTo.init('.js-go-to');

  // initialization of malihu scrollbar
  var $scrollbar = $('.js-scrollbar');
  $.HSCore.components.HSMalihuScrollBar.init($scrollbar);
  $($scrollbar).mCustomScrollbar('scrollTo', '#components li a.active');

  // initialization of slick carousel
  //   $.HSCore.components.HSSlickCarousel.init('.js-slick-carousel');

  // initialization of datatables
  // $.HSCore.components.HSDatatables.init('.js-datatable');

  $.HSCore.components.HSSideNav.init('.js-side-nav');

  $.HSCore.components.HSUnfold.init($('[data-unfold-target]'));

  $.HSCore.components.HSSelect2.init($('.js-custom-select'));

  $.HSCore.components.HSFlatpickr.setConfig({
    // locale: {
    //   firstDayOfWeek: 1,
    //   weekdays: {
    //     shorthand: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
    //   },
    //   months: {
    //     shorthand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月",],
    //     longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月",]
    //   },
    //   rangeSeparator: '-'
    // },
    nextArrow: '<i class="nova-angle-right icon-text icon-text-xs"></i>',
    prevArrow: '<i class="nova-angle-left icon-text icon-text-xs"></i>'
  });
  $.HSCore.components.HSFlatpickr.init('.js-datepicker', {disableMobile: true,});
  // initialization of autocomplet
  //   $.HSCore.components.HSLocalSearchAutocomplete.init('.js-hs-docs-search');

  // initialization of autonomous popups
  //   $.HSCore.components.HSModalWindow.init('[data-modal-target]', '.js-modal-window', {
  //     autonomous: true
  //   });

  // initialization of tabs
  $.HSCore.components.HSBSTabs.init('.js-tabs-to-dropdown');
  $(window).on('resize', function () {
    setTimeout(function () {
      $.HSCore.components.HSBSTabs.init('.js-tabs-to-dropdown');
    }, 200);
  });

  // 选择语言事件回调
  $('#lang-select').on('change', e => {
        // document.cookie += 'lang=' + e.target.value
      var Days = 365;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      var cookieStr = "lang=" + escape(e.target.value) + ";expires=" + exp.toGMTString() + ';path=/';
      if (window != window.top) {
          cookieStr += '; SameSite=None; Secure';
        }
      document.cookie = cookieStr;
      window.location.reload();
  })

  // jquery异步文件下载插件
  $.fn.extend({
      "syncDownload": function (options) {
          $(this).click(function (e) {
              var data = {
                  method: options.method ? options.method : 'get',
                  url: typeof options.url === 'function' ? options.url.call($(this)) : options.url,
                  reload: typeof options.reload === 'function' ? options.reload.call($(this)) : (options.reload || ''),
                  params: typeof options.params === 'function' ? options.params.call($(this)) : options.params,
                  title: options.title
              };
              $.ajax({
                  beforeSend: function (request) {
                      request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                  },
                  type: 'post',
                  headers: {
                      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                  },
                  url: '/s-f-d-t/start',
                  dataType: 'json',
                  data: data,
                  success: function (res) {
                      if (res.code !== 0) {
                          layer.msg(res.message)
                      } else {
                          if (data.reload) {
                              window.location.href = data.reload;
                          } else {
                              location.reload();
                          }
                      }
                  }
              })
          });
      }
  });
})(window.jQuery);

// 按序加载js
function loadJs (arr) {
  let i = arr[Symbol.iterator]()
  let res = i.next()
  function next () {
    if (res.done) return
    let js = document.createElement('script')
    js.onload = function () {
      res = i.next()
      next()
    }
    js.src = res.value
    document.body.appendChild(js)
    js = null
  }
  next()
}
window.loadJs = loadJs
